<template>
	<div
		:id="blok._uid"
		class="bg-(--background-color) px-sm"
		:class="{
			'space-y-2xl': !titleHidden,
			'py-md': !titleHidden || isFilledRichText(blok.ingress),
		}"
		:style="{'--background-color': blok.background_color?.color}"
	>
		<div
			v-if="blok.title && blok.title.length > 0"
			class="mx-auto text-center text-(--color)"
			:class="titleHidden ? 'sr-only' : 'px-sm'"
			:style="{'--color': blok.text_color?.color}"
		>
			<v-h1 v-if="blok.title && titleTag === 'h1'">
				{{ addHyphens(blok.title) }}
			</v-h1>

			<v-h2 v-else-if="blok.title && titleTag === 'h2'">
				{{ addHyphens(blok.title) }}
			</v-h2>

			<v-h3 v-else-if="blok.title && titleTag === 'h3'">
				{{ addHyphens(blok.title) }}
			</v-h3>

			<v-h4 v-else-if="blok.title && titleTag === 'h4'">
				{{ addHyphens(blok.title) }}
			</v-h4>

			<span v-else>
				{{ addHyphens(blok.title) }}
			</span>
		</div>

		<div
			v-if="isFilledRichText(blok.ingress)"
			class="prose text-center wrap-break-word text-(--color)"
			:style="{'--color': blok.text_color?.color}"
		>
			<sb-rich-text :document="blok.ingress" />
		</div>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

import {useHyphenation} from "@pkg/shared/composables/use-hyphenation";
import isFilledRichText from "@pkg/shared/utils/is-filled-rich-text";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-title"}>;
}>();

const titleHidden = computed(() => properties.blok.hide_title ?? false);
const titleTag = computed(() => properties.blok.title_tag ?? "span");

const {hyphenate: addHyphens} = useHyphenation();
</script>
